var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { palette } from '../../../constants';
import { useCanvas } from '../Canvas';
var Line = styled.line(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  pointer-events: none;\n  opacity: 0;\n  stroke: ", ";\n  stroke-width: 2;\n"], ["\n  pointer-events: none;\n  opacity: 0;\n  stroke: ", ";\n  stroke-width: 2;\n"])), palette.orange7);
export var TrackLine = function () {
    var dims = useCanvas();
    return React.createElement(Line, { className: "Chart--TrackLine", y1: 0, y2: dims.boundedHeight });
};
var templateObject_1;
//# sourceMappingURL=TrackLine.js.map